import 'css-chunksrc/client/scenes/planzoneResourceGroupCreation/groupCreationForm/resourcesList/styles.scss';export default {
  "resourcesList": "_resourcesList_1n1mr_1",
  "title": "_title_1n1mr_9",
  "group": "_group_1n1mr_17",
  "resourceForm": "_resourceForm_1n1mr_21",
  "resources": "_resources_1n1mr_1",
  "resource": "_resource_1n1mr_1",
  "addResourceButton": "_addResourceButton_1n1mr_39",
  "marginForm": "_marginForm_1n1mr_46"
};